import { AdministrativeAPIsApiFactory, UserAPIsApiFactory } from '@front-app/api-generated/learning-management-api';
import { createTRApi } from '@front-app/services/api';

const lmsApi = createTRApi('');

export const lmsAdminApi = AdministrativeAPIsApiFactory(undefined, process.env.VUE_APP_API_LMS_BASE_URL, lmsApi);

export type LmsAdminApi = typeof lmsAdminApi;

export const lmsUserApi = UserAPIsApiFactory(undefined, process.env.VUE_APP_API_LMS_BASE_URL, lmsApi);

export type LmsUserApi = typeof lmsUserApi;
